import {deleteDoc, doc, getDoc} from 'firebase/firestore';
import {useState} from 'react';
import {env} from '../../../constants';
import {firebaseAuth, firebaseFirestore} from '../../../setup/firebase';

export interface UseDeleteEtsyBulkUpdateGoogleSheetLinkOptions {
  onCompleted?: () => void;
  onError?: (error: Error) => void;
}

export default function useDeleteEtsyBulkUpdateGoogleSheetLink(
  options?: UseDeleteEtsyBulkUpdateGoogleSheetLinkOptions,
) {
  const [loading, setLoading] = useState(false);

  const deleteLink = async (id: string) => {
    const user = firebaseAuth.currentUser;
    if (!user) {
      const err = new Error('Not authenticated');
      options?.onError?.(err);
      return;
    }
    setLoading(true);
    try {
      const docRef = doc(firebaseFirestore, 'user', user.uid, env.collection.etsyBulkUpdateGoogleSheetLink, id);
      const snap = await getDoc(docRef);
      if (!snap.exists()) {
        options?.onCompleted?.();
        return;
      }
      await deleteDoc(docRef);
      options?.onCompleted?.();
    } catch (e) {
      const err = e instanceof Error ? e : new Error(String(e));
      options?.onError?.(err);
    } finally {
      setLoading(false);
    }
  };

  return [deleteLink, {loading}] as const;
}
